var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardPaymentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 4.96171V2.39816C35 1.07504 33.918 0 32.5862 0H2.41379C1.08205 0 0 1.07504 0 2.39816V4.96171H35Z",
    fill: "#747F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8331V24.6019C0 25.925 1.08205 27.0001 2.41379 27.0001H32.607C33.9388 27.0001 35.0208 25.925 35.0208 24.6019V10.8331H0ZM9.65517 21.9556C7.67836 21.9556 6.0761 20.984 6.0761 19.7849C6.0761 18.5858 7.67836 17.6141 9.65517 17.6141C11.632 17.6141 13.2342 18.5858 13.2342 19.7849C13.2342 20.984 11.632 21.9556 9.65517 21.9556Z",
    fill: "#747F94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPaymentImage);
export default __webpack_public_path__ + "static/media/credit-card-payment-image.7d9dffc642a4d6113f8b54b43c59a1e2.svg";
export { ForwardRef as ReactComponent };